var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('material-card',{attrs:{"title":_vm.$t('views.portal.icons'),"color":_vm.$vuetify.theme.themes.light.secondary,"icon":"palette"}},[_c('edit-images')],1)}
var staticRenderFns = []

export { render, staticRenderFns }